// UserForm.js
import React, { useState, useEffect } from "react";
import "./Users.css";
import {
  BASE_URL,
  DESIGNATION_URL,
  GET_USERS_URL,
  ADD_UPDATE_USER_URL,
  DELETE_USER_URL,
} from "../../constants/Apis";

const UserForm = () => {
  const [designations, setDesignations] = useState([]);
  const [users, setUsers] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
    designation_id: "",
  });

  // Fetch designations
  useEffect(() => {
    fetch(`${BASE_URL}${DESIGNATION_URL}`)
      .then((res) => res.json())
      .then((data) => setDesignations(data))
      .catch((err) => console.error("Failed to fetch designations:", err));
  }, []);

  // Fetch users
  const fetchUsers = () => {
    fetch(`${BASE_URL}${GET_USERS_URL}`)
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error("Failed to fetch users:", err));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleChange = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const bodyData = editingUserId ? { id: editingUserId, ...formData } : formData;

    fetch(`${BASE_URL}${ADD_UPDATE_USER_URL}`, {
      method: "POST", // backend handles both add/update via id
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bodyData),
    })
      .then((res) => res.json())
      .then(() => {
        alert(editingUserId ? "User updated successfully!" : "User added successfully!");
        setFormData({
          name: "",
          email: "",
          mobile: "",
          password: "",
          designation_id: "",
        });
        setEditingUserId(null);
        fetchUsers();
      })
      .catch((err) => console.error("Error saving user:", err));
  };

  const handleEdit = (user) => {
    setEditingUserId(user.id);
    setFormData({
      name: user.name,
      email: user.email,
      mobile: user.mobile,
      password: "", // leave empty for security
      designation_id: user.designation_id,
    });
  };

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    fetch(DELETE_USER_URL, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    })
      .then((res) => res.json())
      .then(() => {
        alert("User deleted successfully!");
        fetchUsers();
      })
      .catch((err) => console.error("Error deleting user:", err));
  };

  return (
    <div className="user-form-card">
      <h2>{editingUserId ? "Edit User" : "Add New User"}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name</label>
          <input type="text" value={formData.name} onChange={(e) => handleChange("name", e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input type="email" value={formData.email} onChange={(e) => handleChange("email", e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Mobile</label>
          <input type="text" value={formData.mobile} onChange={(e) => handleChange("mobile", e.target.value)} required />
        </div>

        {!editingUserId && (
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={formData.password} onChange={(e) => handleChange("password", e.target.value)} required />
          </div>
        )}

        <div className="form-group">
          <label>Designation</label>
          <select value={formData.designation_id} onChange={(e) => handleChange("designation_id", e.target.value)} required>
            <option value="">Select Designation</option>
            {designations.map((des) => (
              <option key={des.id} value={des.id}>
                {des.designation}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="btn-submit">{editingUserId ? "Update User" : "Add User"}</button>
      </form>

      <h3>User List</h3>
      <table className="user-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Designation</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="5">No users found</td>
            </tr>
          ) : (
            users.map((user) => (
              <tr key={user.id}>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.mobile}</td>
                <td>{user.designation}</td>
                <td>
                  <button className="btn-edit" onClick={() => handleEdit(user)}>Edit</button>
                  <button className="btn-delete" onClick={() => handleDelete(user.id)}>Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserForm;
